exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-last-requests-list-component .table td{cursor:pointer}.table-last-requests-list-component .table td span.error{color:#d50000;font-weight:bold}.table-last-requests-list-component .table td span.warning{color:#f5a623;font-weight:bold}.table-last-requests-list-component .table td span.success{color:#18bb66;font-weight:bold}", ""]);

// exports
